module.exports = {
    //Sign up
    SIGNUP_REDIRECT_URL: 'SIGNUP_REDIRECT_URL',
    //Live video statuses
    LIVE_STREAM_IDLE: 'idle',
    LIVE_STREAM_ACTIVE: 'active',
    LIVE_STREAM_UNKNOWN: 'unknown',
    LIVE_STREAM_ERROR: 'error',
    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
    SENTRY_ENABLE_LOCAL: process.env.REACT_APP_SENTRY_ENABLE_LOCAL || false,
    //Websocket event names
    WEBSOCKET_VIDEO_STATUS_CHANGE: 'client-on-video-status-change',
    WEBSOCKET_FORUM_UPVOTE: 'client-on-upvote-forum-entry',
    WEBSOCKET_VIEWER_COUNT_UPDATE: 'client-on-viewer-count-update',
    WEBSOCKET_CHAT_MESSAGE: 'client-on-message',
    WEBSOCKET_CHAT_LUA_BATCH: 'client-on-message-lua-batch',
    WEBSOCKET_REMAINING_PASS_UPDATE: 'client-on-available-passes-update',
    WEBSOCKET_FORUM_NEWEST_ENTRIES_BATCH: 'client-on-newest-forum-entries-batch',
    WEBSOCKET_FORUM_TOP_ENTRIES_BATCH: 'client-on-top-forum-entries-batch',
    WEBSOCKET_FORCE_REFRESH: 'client-on-force-refresh',
    WEBSOCKET_SET_ACTIVE_MUX_ASSET: 'client-on-setting-active-mux-asset',
    WEBSOCKET_WORD_FLOW_BATCH: 'client-on-word-flow-batch',
    WEBSOCKET_WORD_FLOW_ACTIVATED: 'client-on-word-flow-activated',
    WEBSOCKET_INITIATE_PROTOCOL_ARMAGEDDON: 'client-on-initiate-protocol-armageddon',
    WEBSOCKET_DEACTIVATE_PROTOCOL_ARMAGEDDON: 'client-on-deactivate-protocol-armageddon',

    PUSHER_TIMEOUT_MILI: 8 * 1000,
    //Paywall button text
    BTN_TEXT_ENABLED: 'Purchase pass',
    BTN_TEXT_PROCESSING: 'Processing...',
    BTN_TEXT_LOADING: 'Loading...',
    //Payment types
    PAYMENT_METHOD_PAYPAL: 'PayPalAccount',
    PAYMENT_METHOD_CREDIT_CARD: 'CreditCard',
    // Chat
    CHAT: {
        IN_MEMORY_MESSAGE_LIMIT: 40,
        MESSAGE_REFRESH_FETCH_COUNT: 20,
        FORM_HEIGHT: 70,
        INNER_LIST_PADDING: 20,
    },
    FORUM: {
        FORUM_SORT_NEW: 'new',
        FORUM_SORT_TOP: 'top',
        FORUM_MAX_ENTRIES_IN_MEMORY: 100, // This is also used as the upper bound on the initial load entry count
        FORUM_ENTRY_PAGE_SIZE: 20, // This is used for subsequent pagination requests
        UPDATE_SOURCE_NEW_ENTRY: 'new-entry',
        UPDATE_SOURCE_NEW_ENTRY_AUTHORED: 'new-entry-authored',
        UPDATE_SOURCE_FULL_REFRESH: 'full-refresh',
        UPDATE_SOURCE_PAGE_REQUEST: 'pagination-request',
        UPDATE_SOURCE_UPVOTE: 'upvote-update',
        UPDATE_SOURCE_ACK: 'acknowledgement-update',
        UPDATE_SOURCE_ENTRY_REMOVAL: 'entry-removal',
        UPDATE_SOURCE_TOP_RANKED_ENTRY_UPDATE: 'top-ranked-entry-update',
    },
    LUA_DESKTOP_ANIMATION_DURATION_MS: 5000,
    LUA_MOBILE_ANIMATION_DURATION_MS: 3000,
    BATCH_INTERVAL_MS: 5000,
    //Theme
    THEME_DARK: 'dark',
    THEME_LIGHT: 'light',
    MINUTES_BEFORE_START_TIME: 30,
    SKIP_SHOW_PRESENTATION: process.env.REACT_APP_SKIP_PRESENTATION === 'true',
    SET_PAGE_TIME_TO_SET_ANIMATION_COMPLETE_IN_MS: 8000,
    TYPEFORM_FEEDBACK_URL: 'https://jason937807.typeform.com/to/Sy5ueQ',
    CHROMECAST_APP_ID: process.env.REACT_APP_CHROMECAST_APP_ID,
    AUTH_METHOD_SIGNIN: 'signin',
    AUTH_METHOD_SIGNUP: 'signup',
    ARTIST_DASHBOARD_MAX_QUESTIONS: 15,
    ARTIST_DASHBOARD_FORUM_POLLING_INTERVAL: 1000 * 10,
    ARTIST_DASHBOARD_VIEWERS_POLLING_INTERVAL: 1000 * 30,
    SOCIAL_URL: {
        TWITTER: 'https://twitter.com/Cadenza_tv',
        INSTAGRAM: 'https://www.instagram.com/cadenza.tv/',
        FACEBOOK: 'https://www.facebook.com/cadenzatv-105656570852157/',
    },
    CLOSE_CURTAIN_AFTER_MINUTES: 35,
    CURTAIN_ANIMATION_IN_SECONDS: 1,
    //Show scope filter
    SHOW_SCOPE_PUBLIC: 'PUBLIC',
    SHOW_SCOPE_PRIVATE: 'PRIVATE',
}
